export default "__VITE_ASSET__BFnY7hRS__"